<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            History Request
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-container class="px-7" fluid>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="auto">
          <v-btn exact to="/sshcp/request" icon color="bluedarken">
            <v-icon class="icon-bold">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            History Request
          </h1>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto">
          <v-btn color="primary" icon large @click="fetchData()">
            <v-icon color="bluedarken" class="icon-bold icon-large" large>
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-card :loading="loading" class="elevation-card rounded-12 mb-5">
        <v-card-title>
          <div class="mr-2">
            <v-img
              src="@/assets/images/icon-file-text.png"
              width="20"
              height="20"
            />
          </div>
          <span class="fs-14 font-weight-bold primary2--text">
            History {{ detail.unique_code }}
          </span>
          <v-spacer />
          <v-btn
            class="btn-medium mr-2"
            depressed
            color="menuActive"
            dark
            :to="`/sshcp/request/${id}`"
          >
            View Detail Form Request
          </v-btn>
          <v-btn
            class="btn-medium"
            depressed
            color="menuActive"
            dark
            :to="`/sshcp/request/detail/${id}`"
          >
            View Detail Summary
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-simple-table
            fixed-header
            class="spending-table nav-table sshcf-table"
          >
            <template v-slot:default>
              <VuePerfectScrollbar
                class="drawer-menu--scroll"
                :settings="scrollSettings"
              >
                <thead>
                  <tr>
                    <template v-for="header in headers">
                      <th
                        :key="header.text"
                        class="white--text"
                        :class="{
                          [`text-${header.align}`]: true,
                          [header.customClass]: !!header.customClass
                        }"
                        style="font-weight: 700 !important; height: 45px !important;"
                      >
                        <span>{{ header.text }}</span>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <template v-for="header in headers">
                      <td
                        :key="header.name"
                        :class="{
                          [header.tdClass]: true,
                          [`text-${header.align}`]: true,
                          [header.tdClass]: !!header.tdClass
                        }"
                        style="height: 45px !important;"
                      >
                        <!-- <router-link
                            v-if="header.linkable"
                            :to="`/sshcp/request/${item.id}`"
                            class="bluedarken--text text-link"
                          >
                            {{ item.unique_code }}
                          </router-link> -->
                        <span>
                          {{ header | tableRowValue(item) }}
                        </span>
                      </td>
                    </template>
                  </tr>
                  <tr v-if="!items.length">
                    <td :colspan="headers.length" class="text-center">
                      {{ loading ? 'Loading...' : 'No data available' }}
                    </td>
                  </tr>
                </tbody>
              </VuePerfectScrollbar>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { formatDate } from '@/utils/helpers';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: ['id'],
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    columnActive: [],
    breadcrumbs: [
      {
        text: 'SSHCP',
        to: '/sshcp/'
      },
      {
        text: 'Request',
        to: '/sshcp/request/'
      }
    ],
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      page: 1
    },
    loadingDetail: false,
    filter: null,
    loading: false,
    dialog: false,
    headers: [
      {
        text: 'Time',
        align: 'left',
        value: 'created_at',
        tdClass: 'text-capitalize'
      },
      {
        text: 'Subject',
        align: 'left',
        value: 'subject'
      },
      {
        text: 'Description',
        align: 'left',
        value: 'description'
      }
    ],
    detail: {},
    items: []
  }),
  computed: {},
  async mounted() {
    await this.fetchDetail();
    await this.fetchHistory();
  },
  methods: {
    async fetchDetail() {
      // get detail request
      this.loading = true;
      const res = await this.$store.dispatch(
        'sshcp/getFormRequestDetail',
        this.id
      );
      this.detail = res.data.formRequest;
      this.loading = false;
    },
    async fetchHistory() {
      this.loading = true;
      return this.$store
        .dispatch('sshcp/getRequestLogs', {
          paginate: false,
          where: {
            hcp_code: this.detail.unique_code
          },
          sort: 'desc',
          orderBy: 'created_at'
        })
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-tr {
  cursor: pointer;

  &:hover {
    background: #dfdfdf;
  }
}

.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table {
  border-right: 0 !important;
  border-bottom: 0 !important;
}
.v-data-table.table-taxonomy.nav-table td {
  height: 35px !important;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table thead,
.v-data-table.table-taxonomy.nav-table.sshcf-table td:last-child {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
